





































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IRoomServiceRequest } from "@/@types/room-service/room-service";

@Component({})
class RequestCard extends Vue {
  @Prop({ type: Object, required: true }) request!: IRoomServiceRequest;

  get isEmergency(): boolean {
    return (
      this.request.serviceType === "EMERGENCY_ASSISTANCE" ||
      this.request.priority === "CRITICAL" ||
      this.request.status === "ESCALATED"
    );
  }

  get authorLabel(): string {
    if (this.request.createdBy === "STAFF") {
      return String(this.$t("roomService.admin"));
    }
    return String(this.$t("roomService.guest"));
  }

  get serviceKey(): string {
    return this.request.serviceType.toLowerCase();
  }

  get statusKey(): string {
    return this.request.status.toLowerCase();
  }

  get priorityClass(): string {
    return this.request.priority.toLowerCase();
  }

  get serviceIcon(): string {
    const map: Record<string, string> = {
      concierge_call: "bell",
      wake_up: "alarm",
      hygiene_supplies: "basket",
      cleaning_request: "brush",
      do_not_disturb: "moon-stars",
      emergency_assistance: "exclamation-triangle-fill",
    };
    return map[this.serviceKey] || "question-circle";
  }

  get descriptionText(): string {
    const d = this.request.details;
    if (!d) return "";
    if (d.description) return d.description;
    if (d.specialInstructions) return d.specialInstructions;
    return "";
  }

  get wakeUpLabel(): string {
    if (this.request.serviceType !== "WAKE_UP") return "";
    const d = this.request.details;
    if (!d) return "";
    const parts: string[] = [];
    if (d.wakeUpTime) parts.push(this.formatTime(d.wakeUpTime));
    if (d.wakeUpMethod) {
      const method = String(
        this.$t(`roomService.wakeUpMethod.${d.wakeUpMethod}`)
      );
      if (method) parts.push(method);
    }
    return parts.join(" · ");
  }

  get createdAgo(): string {
    const created =
      this.request.timestamps?.createdAt || this.request.createdAt;
    if (!created) return "";
    const diff = Date.now() - new Date(created).getTime();
    const min = Math.floor(diff / 60000);
    if (min < 1) return String(this.$t("roomService.justNow"));
    if (min < 60) return `${min} ${this.$t("roomService.minAgo")}`;
    const hours = Math.floor(min / 60);
    if (hours < 24) return `${hours} ${this.$t("roomService.hoursAgo")}`;
    const days = Math.floor(hours / 24);
    return `${days} ${this.$t("roomService.daysAgo")}`;
  }

  formatTime(value: Date | string): string {
    const d = new Date(value);
    const h = String(d.getHours()).padStart(2, "0");
    const m = String(d.getMinutes()).padStart(2, "0");
    return `${h}:${m}`;
  }
}
export default RequestCard;
